var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      attrs: { "ok-disabled": _vm.state.isAdding },
      on: { ok: _vm.saveData, shown: _vm.clearName },
      model: {
        value: _vm.display,
        callback: function($$v) {
          _vm.display = $$v
        },
        expression: "display"
      }
    },
    [
      _c("div", { attrs: { slot: "modal-title" }, slot: "modal-title" }, [
        _vm._v(
          "\n    " +
            _vm._s(_vm.$t("message.booking.contact_step.save_my_place")) +
            "\n  "
        )
      ]),
      _vm._v(" "),
      _c("section", { staticClass: "section-save-place text-black" }, [
        _c("div", { staticClass: "form-group" }, [
          _c("label", { attrs: { for: "place-name" } }, [
            _vm._v(_vm._s(_vm.$t("message.booking.contact_step.place_name")))
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "text-remark mb-2" }, [
            _vm._v(
              _vm._s(_vm.$t("message.booking.contact_step.place_name_remark"))
            )
          ]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.placeName,
                expression: "placeName"
              }
            ],
            ref: "placeName",
            staticClass: "form-control input-jumbo",
            attrs: { type: "text", id: "place-name", required: "" },
            domProps: { value: _vm.placeName },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.placeName = $event.target.value
              }
            }
          })
        ]),
        _vm._v(" "),
        _c("hr"),
        _vm._v(" "),
        _c("div", { staticClass: "mt-3" }, [
          _c("label", [
            _vm._v(_vm._s(_vm.$t("message.my_listings.checklist")))
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "text-remark mb-2" }, [
            _vm._v(_vm._s(_vm.$t("message.my_listings.checklist_remark")))
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-inline row" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.checklistData,
                expression: "checklistData"
              }
            ],
            staticClass: "form-control col-8 col-sm-8",
            attrs: {
              id: "checklist",
              type: "text",
              placeholder: _vm.$t("message.my_listings.add_checklist")
            },
            domProps: { value: _vm.checklistData },
            on: {
              keyup: function($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                ) {
                  return null
                }
                return _vm.addChecklist.apply(null, arguments)
              },
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.checklistData = $event.target.value
              }
            }
          }),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "btn btn-success ml-2",
              attrs: { type: "button" },
              on: { click: _vm.addChecklist }
            },
            [
              _c("i", { staticClass: "far fa-plus" }),
              _vm._v(" " + _vm._s(_vm.$t("message.button.add")) + "\n      ")
            ]
          )
        ]),
        _vm._v(" "),
        _c(
          "div",
          [
            _c(
              "draggable",
              {
                model: {
                  value: _vm.arrChecklist,
                  callback: function($$v) {
                    _vm.arrChecklist = $$v
                  },
                  expression: "arrChecklist"
                }
              },
              _vm._l(_vm.arrChecklist, function(checklist, index) {
                return _c("div", { key: index, staticClass: "card" }, [
                  _c("div", { staticClass: "card-body py-2" }, [
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col-10 p-0" }, [
                        _c("i", {
                          staticClass: "fas fa-check -status-accepted"
                        }),
                        _vm._v(
                          " \n                " +
                            _vm._s(checklist) +
                            "\n              "
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-2 p-0 text-right" }, [
                        _c("i", {
                          staticClass: "fas fa-times pointer-item",
                          on: {
                            click: function($event) {
                              return _vm.removeChecklist(index)
                            }
                          }
                        })
                      ])
                    ])
                  ])
                ])
              }),
              0
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          attrs: { slot: "modal-cancel" },
          on: {
            click: function($event) {
              _vm.display = false
            }
          },
          slot: "modal-cancel"
        },
        [_vm._v(_vm._s(_vm.$t("message.button.close")))]
      ),
      _vm._v(" "),
      _c("div", { attrs: { slot: "modal-ok" }, slot: "modal-ok" }, [
        _vm._v(_vm._s(_vm.$t(_vm.isAdding)))
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2db09a66", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2db09a66","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/booking/components/SavePlaceModal.vue
// module id = 1722
// module chunks = 0